import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=55822106&scoped=true&lang=pug&"
import script from "./ProductSelector.vue?vue&type=script&lang=js&"
export * from "./ProductSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelector.vue?vue&type=style&index=0&id=55822106&prod&lang=sass&scoped=true&"
import style1 from "./ProductSelector.vue?vue&type=style&index=1&id=55822106&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55822106",
  null
  
)

export default component.exports